export default __webpack_public_path__ + "assets/icons/iconSearch.34ad7554.svg";